import React from 'react';
import PropTypes from 'prop-types';
import { compose, withProps } from 'recompose';
import memoize from 'lodash/memoize';

import InputGroup from './InputGroup';
import withStaffingCompanies from '../../entities/StaffingCompany/withStaffingCompanies';
import * as validators from './validators';

const formatValue = value => (value > 0 ? `${(Math.max(0, Math.min(1, value)) * 100).toFixed(0)}` : '');

function TaxInput({ taxRate, ...otherInputProps }) {
  return (
    <InputGroup
      {...otherInputProps}
      type="text"
      placeholder={formatValue(taxRate)}
      defaultValue={formatValue(taxRate)}
      inputAddonAfter="%"
    />
  );
}

TaxInput.propTypes = {
  taxRate: PropTypes.number.isRequired,
};

const extendedTaxInput = compose(
  withStaffingCompanies(true),
  withProps(({ staffingCompanies }) => {
    if (staffingCompanies.length === 0) {
      return {
        taxRate: 0,
      };
    }

    return {
      taxRate: staffingCompanies[0].standardTaxRate,
    };
  }),
)(TaxInput);
extendedTaxInput.normalize = (value) => {
  const v = (`${value}`.replace(/[\D]/, '') / 100).toFixed(2);
  return v > 0 ? v : null;
};
extendedTaxInput.format = formatValue;
extendedTaxInput.validator = memoize(
  validators.ltEqNull(1, () => 'Skattesatsen får vara max 100%'),
);

export default extendedTaxInput;
